/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sameheight[_ngcontent-%COMP%]{min-height:550px}@media screen and (max-width:1280px){.sameheight[_ngcontent-%COMP%]{min-height:750px}}@media screen and (max-width:1024px){.sameheight[_ngcontent-%COMP%]{min-height:700px}}@media screen and (max-width:768px){.sameheight[_ngcontent-%COMP%]{min-height:650px}}@media screen and (max-width:510px){.sameheight[_ngcontent-%COMP%]{min-height:10px}}\n/*# sourceMappingURL=welcome.component.css.map*/"];
export { styles as styles };
